export default function categoryHasImages(items)
{
  return items.filter((item) => {
    return item.photo
  }).length > 0
}